import axios from "axios";

import {
  COMPANY_SMTP_PROVIDER_PRESETS,
  getCompanySmtpProviderPreset,
} from "@/Utile/companyEmailSmtp.mjs";

export const USER_EMAIL_ACCOUNTS_ENDPOINT = "/company-email/user/accounts";

export const USER_EMAIL_PROVIDER_PRESETS = COMPANY_SMTP_PROVIDER_PRESETS;

const toBoolean = (value) => value === true || value === 1 || value === "1";

const trimOrNull = (value) => {
  const trimmed = String(value || "").trim();
  return trimmed || null;
};

export const createUserEmailDraft = ({ userEmail = "", userName = "" } = {}) => ({
  id: null,
  name: "",
  description: "",
  providerKey: "generic",
  transportMode: "company_default",
  isDefault: false,
  status: "active",
  companySmtpAccountId: null,
  host: "",
  port: 587,
  secure: false,
  requireTLS: true,
  authType: "password",
  username: "",
  password: "",
  fromEmail: userEmail || "",
  fromName: userName || "",
  replyToEmail: "",
});

export const applyUserEmailProviderPreset = (draft, providerKey) => {
  const preset = getCompanySmtpProviderPreset(providerKey);
  return {
    ...draft,
    providerKey: preset.value,
    host: preset.host || draft.host || "",
    port: preset.port || draft.port || 587,
    secure: Boolean(preset.secure),
    requireTLS: Boolean(preset.requireTLS),
    authType: preset.authType || draft.authType || "password",
  };
};

export const normalizeUserEmailAccount = (account = {}) => ({
  ...account,
  id: Number(account.id),
  company_smtp_account_id: account.company_smtp_account_id
    ? Number(account.company_smtp_account_id)
    : null,
  is_default: toBoolean(account.is_default),
  secure: toBoolean(account.secure),
  require_tls: toBoolean(account.require_tls),
  port: account.port ? Number(account.port) : null,
});

export const buildUserEmailPayload = (draft, { includePassword = false } = {}) => {
  const transportMode = draft.transportMode === "own_smtp" ? "own_smtp" : "company_default";
  const isOwnSmtp = transportMode === "own_smtp";
  const authType = isOwnSmtp && draft.authType !== "none" ? "password" : "none";
  const payload = {
    name: String(draft.name || "").trim(),
    description: trimOrNull(draft.description),
    providerKey: isOwnSmtp ? draft.providerKey || "generic" : "generic",
    transportMode,
    isDefault: Boolean(draft.isDefault),
    status: draft.status || "active",
    companySmtpAccountId: null,
    host: isOwnSmtp ? String(draft.host || "").trim() : null,
    port: isOwnSmtp ? Number(draft.port) : null,
    secure: isOwnSmtp ? Boolean(draft.secure) : false,
    requireTLS: isOwnSmtp ? Boolean(draft.requireTLS) : true,
    authType,
    username: isOwnSmtp && authType === "password" ? trimOrNull(draft.username) : null,
    fromEmail: String(draft.fromEmail || "").trim(),
    fromName: trimOrNull(draft.fromName),
    replyToEmail: trimOrNull(draft.replyToEmail),
  };

  if (isOwnSmtp && authType === "password" && includePassword) {
    payload.password = String(draft.password || "").trim();
  }

  return payload;
};

export const fetchUserEmailAccounts = () => axios.get(USER_EMAIL_ACCOUNTS_ENDPOINT);

export const createUserEmailAccount = (payload) =>
  axios.post(USER_EMAIL_ACCOUNTS_ENDPOINT, payload);

export const updateUserEmailAccount = (id, payload) =>
  axios.patch(`${USER_EMAIL_ACCOUNTS_ENDPOINT}/${id}`, payload);

export const deleteUserEmailAccount = (id) =>
  axios.delete(`${USER_EMAIL_ACCOUNTS_ENDPOINT}/${id}`);

export const testUserEmailAccount = (id) =>
  axios.post(`${USER_EMAIL_ACCOUNTS_ENDPOINT}/${id}/test`, {}, { validateStatus: () => true });

export const sendUserEmailTestEmail = (id, to) =>
  axios.post(`${USER_EMAIL_ACCOUNTS_ENDPOINT}/${id}/send-test`, { to });
